import { useMutation } from '@tanstack/react-query';

import { login } from './login.api';
import { LoginRequest } from './login.types';
import { MutationConfig } from '@/react-query';
import { useAppContext } from '@/context/context';

type LoginOptions = MutationConfig<typeof login>;

export function useLogin(options: LoginOptions = {}) {
  const { setSnackbar } = useAppContext();

  return useMutation({
    mutationFn: async (data: LoginRequest) => {
      const response = await login(data);
      return response;
    },
    onSuccess: data => {
      options.onSuccess?.(data as any, {} as any, {}, {} as any);
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.error || 'שגיאה במהלך התחברות';
      setSnackbar({ severity: 'error', message: errorMessage, open: true });

      console.error('Error logging in:', error);
    },
    ...options
  });
}
